import React, { useState, useEffect } from "react";
import Joi from "joi";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import statusReportFilterService from "../services/statusReportFilterService";
import ShopService from "../services/shopService";
import * as AuthDevicesService from "../services/authDeviceService";
import { toast } from "react-toastify";

const AddOrEditFilterModal = ({ show, onHide, filter, onFilterChange }) => {
  const [data, setData] = useState({
    name: "",
    type: "shops",
    data: {},
  });
  const [devicesNames, setDevicesNames] = useState([]);
  const [shopNames, setShopNames] = useState([]);
  const [shopInputValue, setShopInputValue] = useState("");
  const [shopDescriptionValue, setShopDescriptionValue] = useState("");
  const [deviceInputValue, setDeviceInputValue] = useState("");
  const [deviceDescriptionValue, setDeviceDescriptionValue] = useState("");
  const [filteredShops, setFilteredShops] = useState([]);
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [showShopDropdown, setShowShopDropdown] = useState(false);
  const [showDeviceDropdown, setShowDeviceDropdown] = useState(false);
  const [errors, setErrors] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  const schema = Joi.object({
    name: Joi.string().min(1).max(1000).optional().label("Nazwa").messages({
      "string.empty": "Nazwa nie może być pusta",
      "string.min": "Nazwa musi mieć co najmniej {#limit} znak",
      "string.max": "Nazwa może mieć maksymalnie {#limit} znaków",
      "any.required": "Nazwa jest wymagana",
    }),
    type: Joi.string().valid("shops", "devices").optional().label("Typ").messages({
      "any.only": "Typ musi być 'drogeria' lub 'urządzenie'",
      "any.required": "Typ jest wymagany",
    }),
    data: Joi.object().label("Dane filtru"),
  });

  const getData = async () => {
    try {
      const shopNames = await ShopService.getAllShopNames();
      const deviceNames = await AuthDevicesService.getAllDevicesNames();
      console.log(shopNames);
      console.log(deviceNames);
      setDevicesNames([...deviceNames.data]);
      setShopNames([...shopNames.data]);
    } catch (e) {
      console.error("Error fetching shop/device names:", e);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    if (filter) {
      // Edycja istniejącego filtru
      const newData = {
        name: filter.name || "",
        type: filter.type || "shops",
        data: filter.data || (filter.type === "devices" ? { devices: [] } : { shops: [] }),
      };
      setData(newData);
      setIsEdit(true);
    } else {
      // Reset dla nowego filtru
      setData({
        name: "",
        type: "shops",
        data: { shops: [] },
      });
      setIsEdit(false);
      setErrors({});
    }
  }, [filter, show]);

  const validateProperty = (name, value) => {
    // Handle nested properties for validation
    if (name.includes(".")) {
      return null; // Skip validation for nested properties for now
    }

    const obj = { [name]: value };
    const { error } = schema.validate(obj, { allowUnknown: true });
    return error ? error.details[0].message : null;
  };

  const validate = () => {
    console.log(data);
    const { error } = schema.validate(data, { abortEarly: false });
    if (!error) return null;

    const newErrors = {};
    for (let item of error.details) {
      newErrors[item.path[0]] = item.message;
    }
    console.log(newErrors);
    return newErrors;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // Handle nested properties
    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setData((prevData) => ({
        ...prevData,
        [parent]: {
          ...prevData[parent],
          [child]: value,
        },
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    // Validate field
    const newErrors = { ...errors };
    const errorMessage = validateProperty(name, value);
    if (errorMessage) {
      newErrors[name] = errorMessage;
    } else {
      delete newErrors[name];
    }
    setErrors(newErrors);
  };

  const handleTypeChange = (event) => {
    const newType = event.target.value;

    setData((prevData) => ({
      ...prevData,
      type: newType,
      data: newType === "shops" ? { shops: [] } : { devices: [] },
    }));
    const newErrors = validate();
    setErrors(newErrors || {});
  };

  // Funkcje obsługujące drogerie
  const handleShopInputChange = (e) => {
    let value = e.target.value;

    // Ograniczenie do 4 cyfr
    value = value.replace(/\D/g, "").substring(0, 4);
    setShopInputValue(value);

    // Filtruj drogerie na podstawie wprowadzonego tekstu
    const filtered = shopNames.filter(
      (shop) =>
        shop.name.toLowerCase().includes(value.toLowerCase()) &&
        !data.data.shops?.some((selectedShop) => selectedShop._id === shop._id)
    );
    setFilteredShops(filtered);
    setShowShopDropdown(value.length > 0 && filtered.length > 0);
  };

  const addShopFromInput = () => {
    if (!shopInputValue.trim() || shopInputValue.length !== 4 || !/^\d{4}$/.test(shopInputValue)) {
      return;
    }

    // Sprawdź czy istnieje drogeria o takiej nazwie
    const existingShop = shopNames.find((shop) => shop.name.toLowerCase() === shopInputValue.toLowerCase());

    if (existingShop) {
      // Dodaj istniejącą drogerię z opisem
      if (!data.data.shops?.some((shop) => shop._id === existingShop._id)) {
        const shopWithDescription = {
          ...existingShop,
          description: shopDescriptionValue.trim(),
        };
        console.log(shopWithDescription);
        setData((prevData) => ({
          ...prevData,
          data: {
            ...prevData.data,
            shops: [...(prevData.data.shops || []), shopWithDescription],
          },
        }));
      }
    } else {
      return;
    }

    setShopInputValue("");
    setShopDescriptionValue("");
    setShowShopDropdown(false);
  };

  const selectShopFromDropdown = (shop) => {
    if (!data.data.shops?.some((selectedShop) => selectedShop._id === shop._id)) {
      setShopInputValue(shop.name);
    }
    // setShopInputValue("");
    // setShopDescriptionValue("");
    setShowShopDropdown(false);
  };

  // Funkcje obsługujące urządzenia
  const handleDeviceInputChange = (e) => {
    const value = e.target.value;
    setDeviceInputValue(value);

    // Filtruj urządzenia na podstawie wprowadzonego tekstu
    const filtered = devicesNames.filter(
      (device) =>
        device.sn.toLowerCase().startsWith(value.toLowerCase()) &&
        !data.data.devices?.some((selectedDevice) => selectedDevice._id === device._id)
    );
    setFilteredDevices(filtered);
    setShowDeviceDropdown(value.length > 0 && filtered.length > 0);
  };

  const addDeviceFromInput = () => {
    if (!deviceInputValue.trim()) return;

    // Sprawdź czy istnieje urządzenie o takiej nazwie
    const existingDevice = devicesNames.find((device) => device.sn.toLowerCase() === deviceInputValue.toLowerCase());

    if (existingDevice) {
      // Dodaj istniejące urządzenie z opisem
      if (!data.data.devices?.some((device) => device._id === existingDevice._id)) {
        const deviceWithDescription = {
          ...existingDevice,
          description: deviceDescriptionValue.trim(),
        };
        setData((prevData) => ({
          ...prevData,
          data: {
            ...prevData.data,
            devices: [...(prevData.data.devices || []), deviceWithDescription],
          },
        }));
      }
      setDeviceInputValue("");
      setDeviceDescriptionValue("");
      setShowDeviceDropdown(false);
    } else {
      return;
    }
  };

  const selectDeviceFromDropdown = (device) => {
    if (!data.data.devices?.some((selectedDevice) => selectedDevice._id === device._id)) {
      // const deviceWithDescription = {
      //   ...device,
      //   description: deviceDescriptionValue.trim(),
      // };
      // setData((prevData) => ({
      //   ...prevData,
      //   data: {
      //     ...prevData.data,
      //     devices: [...(prevData.data.devices || []), deviceWithDescription],
      //   },
      // }));
      setDeviceInputValue(device.sn);
    }
    // setDeviceInputValue("");
    // setDeviceDescriptionValue("");
    setShowDeviceDropdown(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const newErrors = validate();
    setErrors(newErrors || {});
    if (newErrors) return;

    try {
      const filterData = {
        name: data.name,
        type: data.type,
        data: data.data,
      };

      if (isEdit && filter) {
        console.log(filterData);
        await statusReportFilterService.update(filter._id, filterData);
        toast.success("Filtr został zaktualizowany");
      } else {
        console.log(filterData);
        await statusReportFilterService.create(filterData);
        toast.success("Filtr został utworzony");
      }

      if (onFilterChange) {
        onFilterChange();
      }

      onHide();
    } catch (error) {
      console.error("Błąd podczas zapisywania filtru:", error);
      toast.error("Wystąpił błąd podczas zapisywania filtru");
    }
  };

  const renderInput = (name, label, type = "text", placeholder = "") => {
    const value = name.includes(".") ? data[name.split(".")[0]][name.split(".")[1]] : data[name];

    return (
      <Form.Group className="mb-3">
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={handleInputChange}
          isInvalid={!!errors[name]}
        />
        {errors[name] && <Form.Control.Feedback type="invalid">{errors[name]}</Form.Control.Feedback>}
      </Form.Group>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edytuj filtr" : "Dodaj nowy filtr"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderInput("name", "Nazwa filtru", "text", "Wprowadź nazwę filtru")}

          <Form.Group className="mb-3">
            <Form.Label>Typ filtru</Form.Label>
            <Form.Select
              name="type"
              value={data.type}
              onChange={handleTypeChange}
              isInvalid={!!errors.type}
            >
              <option value="shops">Filtr drogerii</option>
              <option value="devices">Filtr urządzeń</option>
            </Form.Select>
            {errors.type && <Form.Control.Feedback type="invalid">{errors.type}</Form.Control.Feedback>}
          </Form.Group>

          {data.type === "shops" && (
            <div>
              <h6 className="text-muted mb-3">Wybierz drogerie</h6>

              <Form.Group className="mb-3">
                <Form.Label>Dodaj drogerię do filtru</Form.Label>
                <div style={{ position: "relative" }}>
                  <div className="row g-2 mb-2">
                    <div className="col-3">
                      <Form.Control
                        type="text"
                        placeholder="Wpisz 4-cyfrowy kod drogerii (np. 1234)..."
                        value={shopInputValue}
                        onChange={handleShopInputChange}
                        onFocus={() => setShowShopDropdown(filteredShops.length > 0)}
                        onBlur={() => {
                          // Opóźnienie aby dropdown zdążył obsłużyć kliknięcie
                          setTimeout(() => setShowShopDropdown(false), 150);
                        }}
                        maxLength={4}
                      />
                    </div>
                    <div className="col-6">
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Opis drogerii (opcjonalny)..."
                        value={shopDescriptionValue}
                        onChange={(e) => setShopDescriptionValue(e.target.value)}
                        maxLength={500}
                      />
                    </div>
                    <div className="col-3 d-flex align-items-centers">
                      <Button
                        variant="outline-primary m-auto"
                        onClick={addShopFromInput}
                        disabled={shopInputValue.length !== 4 || !/^\d{4}$/.test(shopInputValue)}
                      >
                        Dodaj drogerię
                      </Button>
                    </div>
                  </div>

                  {showShopDropdown && filteredShops.length > 0 && (
                    <div
                      className="dropdown-menu show w-100 mt-1"
                      style={{
                        position: "absolute",
                        top: "100%",
                        zIndex: 1000,
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {filteredShops.map((shop) => (
                        <button
                          key={shop._id}
                          type="button"
                          className="dropdown-item"
                          onClick={() => selectShopFromDropdown(shop)}
                          onMouseDown={(e) => e.preventDefault()} // Zapobiega blur inputu
                        >
                          <div>
                            <strong>{shop.name}</strong>
                            {/* <small className="text-muted ms-2">ID: {shop._id}</small> */}
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </Form.Group>

              <div className="mb-3">
                <Form.Label>Wybrane drogerie ({data.data.shops?.length || 0})</Form.Label>
                {data.data.shops && data.data.shops.length > 0 ? (
                  <div
                    className="border p-2 rounded"
                    style={{ maxHeight: "200px", overflowY: "auto" }}
                  >
                    {data.data.shops.map((shop, index) => (
                      <div
                        key={shop._id}
                        className="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded"
                      >
                        <div>
                          <div>
                            <strong>{shop.name}</strong>
                            {shop.description && <small className="text-muted ms-2">({shop.description})</small>}
                          </div>
                        </div>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => {
                            setData((prevData) => ({
                              ...prevData,
                              data: {
                                ...prevData.data,
                                shops: prevData.data.shops.filter((_, i) => i !== index),
                              },
                            }));
                          }}
                        >
                          Usuń
                        </Button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="border p-3 rounded text-center text-muted">
                    <p className="mb-0">Brak wybranych drogerii</p>
                    <small>Wybierz drogerie z listy powyżej</small>
                  </div>
                )}
              </div>
            </div>
          )}

          {data.type === "devices" && (
            <div>
              <h6 className="text-muted mb-3">Wybierz urządzenia</h6>

              <Form.Group className="mb-3">
                <Form.Label>Dodaj urządzenie do filtru</Form.Label>
                <div style={{ position: "relative" }}>
                  <div className="row g-2 mb-2">
                    <div className="col-3">
                      <Form.Control
                        type="text"
                        placeholder="Wpisz nazwę urządzenia lub wybierz z listy..."
                        value={deviceInputValue}
                        onChange={handleDeviceInputChange}
                        onFocus={() => setShowDeviceDropdown(filteredDevices.length > 0)}
                        onBlur={() => {
                          // Opóźnienie aby dropdown zdążył obsłużyć kliknięcie
                          setTimeout(() => setShowDeviceDropdown(false), 150);
                        }}
                      />
                    </div>
                    <div className="col-6">
                      <Form.Control
                        // type="text"
                        as="textarea"
                        rows={1}
                        placeholder="Opis urządzenia (opcjonalny)..."
                        value={deviceDescriptionValue}
                        onChange={(e) => setDeviceDescriptionValue(e.target.value)}
                        maxLength={500}
                      />
                    </div>

                    <div className="col-3 d-flex align-items-centers ">
                      <Button
                        variant="outline-primary m-auto"
                        onClick={addDeviceFromInput}
                        disabled={!deviceInputValue.trim()}
                      >
                        Dodaj urządzenie
                      </Button>
                    </div>
                  </div>

                  {showDeviceDropdown && filteredDevices.length > 0 && (
                    <div
                      className="dropdown-menu show w-100 mt-1"
                      style={{
                        position: "absolute",
                        top: "100%",
                        zIndex: 1000,
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {filteredDevices.map((device) => (
                        <button
                          key={device._id}
                          type="button"
                          className="dropdown-item"
                          onClick={() => selectDeviceFromDropdown(device)}
                          onMouseDown={(e) => e.preventDefault()} // Zapobiega blur inputu
                        >
                          <div>
                            <strong>{device.sn}</strong>
                            {/* <small className="text-muted ms-2">ID: {device._id}</small> */}
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </Form.Group>

              <div className="mb-3">
                <Form.Label>Wybrane urządzenia ({data.data.devices?.length || 0})</Form.Label>
                {data.data.devices && data.data.devices.length > 0 ? (
                  <div
                    className="border p-2 rounded"
                    style={{ maxHeight: "200px", overflowY: "auto" }}
                  >
                    {data.data.devices.map((device, index) => (
                      <div
                        key={device._id}
                        className="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded"
                      >
                        <div>
                          <div>
                            <strong>{device.sn}</strong>
                            {device.description && <small className="text-muted">({device.description})</small>}
                          </div>
                        </div>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => {
                            setData((prevData) => ({
                              ...prevData,
                              data: {
                                ...prevData.data,
                                devices: prevData.data.devices.filter((_, i) => i !== index),
                              },
                            }));
                          }}
                        >
                          Usuń
                        </Button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="border p-3 rounded text-center text-muted">
                    <p className="mb-0">Brak wybranych urządzeń</p>
                    <small>Wybierz urządzenia z listy powyżej</small>
                  </div>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={onHide}
            variant="secondary"
          >
            Anuluj
          </Button>
          <Button
            type="submit"
            variant="primary"
          >
            {isEdit ? "Zaktualizuj" : "Dodaj"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddOrEditFilterModal;
